import { InjectionToken } from '@angular/core';
import { EnvConfig } from '@shared/definitions';

export const ENV_CONFIG = new InjectionToken<EnvConfig>('env config');
